// eslint-disable-next-line import/prefer-default-export
export const getEquipmentDescription = equipment =>
  `ID: ${equipment.id} - ${equipment.model} - ${equipment.brand.name}`;
